module.exports = __webpack_public_path__ + "img/towers.8a4ab0d1.jpeg";